let messaages_zh = {
	Salutation: {
		required: '请选择称呼。',
	},
	FirstName: {
		required: '请输入名字。',
	},
	LastName: {
		required: '请输入姓氏。',
	},
	Email: {
		required: '请输入电子邮件地址。',
		email: '请输入有效的电子邮件地址。',
	},
	Country: {
		required: '请选择一个国家。',
	},
	Postcode: {
		required: '请选择邮政编码。',
	},
	Password: {
		required: '请输入密码。',
	},
	ConfirmPassword: {
		required: '请输入密码进行确认。',
		equalTo: '请确保密码匹配。',
	},
	TermsAndConditions: {
		required: '请同意条款和条件。',
	}
};

export function messages_zh() {
	return messaages_zh;
}
